module.exports = __webpack_public_path__ + "img/Button_Menu.1b1eea4a.png";